import * as Sentry from '@sentry/react';

export const handlePlyrError = (
  type: 'audio' | 'video',
  plyrError: Plyr.PlyrEvent,
  additionalInfo: { lastAction?: string },
): void => {
  let actualError;
  let hasFoundActualError;

  try {
    actualError = plyrError.detail.plyr.elements.container?.getElementsByTagName(type)[0]?.error;
    hasFoundActualError = true;
  } catch (e) {
    hasFoundActualError = false;
  }

  const errorSummary = {
    message: `Plyr ${type} error`,
    plyrError,
    actualError,
    hasFoundActualError,
    url: globalThis?.location?.href,
    mediaSource: plyrError?.detail?.plyr?.source,
    ...additionalInfo,
  };

  // eslint-disable-next-line no-console
  console.warn(errorSummary);

  Sentry.captureException(errorSummary);
};
